import { Link } from 'react-router-dom';
import Subtitle from "./Subtitle";

const WorkCard = ({ label, color = 'red', to = '#', children }) => {
    return (
        <Link to={to} className="work-card-link">
            <div className={`work-card work-card--${color}`}>
                <div className="work-card-wrapper">
                    {children}
                </div>
                <Subtitle>{label}</Subtitle>
            </div>
        </Link>
    );
};

export default WorkCard;